import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap"; // Import Bootstrap Button

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/login"); // Redirect to the login screen
    };

    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">
                    {/* Back Button at the Top */}
                    <div className="text-start mb-4">
                        <Button variant="secondary" onClick={handleBack}>
                            &larr; Back to Login
                        </Button>
                    </div>

                    <h1 className="card-title text-center mb-4">Privacy Policy for {process.env.REACT_APP_NAME}</h1>
                    <p className="text-muted text-center">Effective Date: [2024-08-21]</p>

                    <p>
                        {process.env.REACT_APP_NAME} ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information when you use our <strong>{process.env.REACT_APP_NAME}</strong> ("the App"), which is designed to create posts on <strong>TikTok</strong>, and fetch all posts from your <strong>TikTok</strong> accounts.
                    </p>

                    <h2 className="mt-4">1. Information We Collect</h2>
                    <p>
                        When you use the App, we may collect the following types of information:
                    </p>
                    <ul>
                        <li>
                            <strong>TikTok Account Information:</strong> We may collect your <strong>TikTok</strong> usernames, user IDs, and access tokens to allow the App to interact with your <strong>TikTok</strong> accounts.
                        </li>
                        <li>
                            <strong>Content Data:</strong> The App will have access to the posts you create, fetch, or interact with via your <strong>TikTok</strong> accounts. This includes text, images, videos, and metadata associated with your posts.
                        </li>
                        <li>
                            <strong>Usage Data:</strong> We may collect information about how you use the App, including the frequency and duration of use, interactions within the App, and any errors or issues encountered.
                        </li>
                    </ul>

                    <h2 className="mt-4">2. How We Use Your Information</h2>
                    <p>
                        We use the information collected through the App for the following purposes:
                    </p>
                    <ul>
                        <li>
                            <strong>To Provide and Improve the Service:</strong> We use your <strong>TikTok</strong> account information to enable the App to create and fetch posts on your behalf. We may also use the data to improve the functionality and user experience of the App.
                        </li>
                        <li>
                            <strong>To Communicate with You:</strong> We may use your contact information to send you updates, notifications, or support messages related to the App.
                        </li>
                        <li>
                            <strong>To Ensure Compliance:</strong> We may use your information to ensure that the App's use complies with <strong>TikTok</strong> policies and our terms of service.
                        </li>
                    </ul>

                    <h2 className="mt-4">3. How We Share Your Information</h2>
                    <p>
                        We do not sell, trade, or otherwise transfer your personal information to outside parties except as described below:
                    </p>
                    <ul>
                        <li>
                            <strong>With Your Consent:</strong> We may share your information with third parties if you explicitly authorize us to do so.
                        </li>
                        <li>
                            <strong>Service Providers:</strong> We may share your information with third-party service providers who assist us in operating the App or providing services on our behalf. These service providers are contractually obligated to protect your information and only use it for the purposes we specify.
                        </li>
                        <li>
                            <strong>Legal Compliance:</strong> We may disclose your information if required to do so by law or if we believe such action is necessary to comply with legal obligations, protect our rights, or ensure the safety of our users.
                        </li>
                    </ul>

                    <h2 className="mt-4">4. Data Security</h2>
                    <p>
                        We implement a variety of security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please be aware that no security measure is perfect, and we cannot guarantee the absolute security of your information.
                    </p>

                    <h2 className="mt-4">5. Your Rights</h2>
                    <p>
                        You have the right to access, update, or delete the information we hold about you. If you wish to exercise these rights, please contact us at <a href="mailto:admin@indieauthormedia.com">admin@indieauthormedia.com</a>.
                    </p>

                    <h2 className="mt-4">6. Changes to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the updated policy on our website or through the App.
                    </p>

                    <h2 className="mt-4">7. Contact Us</h2>
                    <p>
                        If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
                    </p>
                    <address>
                        <strong>Indie Author Academy LLC</strong><br />
                        657 Timberfalls Lane<br />
                        Henderson, NV 89015 US<br />
                        <a href="mailto:admin@indieauthormedia.com">admin@indieauthormedia.com</a>
                    </address>

                    {/* Back Button at the Bottom */}
                    <div className="text-center mt-4">
                        <Button variant="secondary" onClick={handleBack}>
                            &larr; Back to Login
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;